<ng-container *ngIf="(state$ | async) !== SidebarState.HIDDEN">
    <div class="header-sidebar" [class]="state$ | async">
        <div class="circle" [class.circle_closed]="(state$ | async) !== SidebarState.CLOSED" (click)="toggle()">
            <app-kebab-menu></app-kebab-menu>
        </div>
        <ng-container *ngIf="(state$ | async) !== SidebarState.CLOSED">
            <app-logo class="logo-newcard"></app-logo>
        </ng-container>
    </div>
    <div [class]="[theme, state$ | async]" appHover class="sidebar">
        <div class="body-sidebar">
            <div class="sidebar-top">
                <div
                    routerLinkActive="active"
                    routerLink="/dashboard/unknown"
                    class="btn-nav d-flex flex-row mt-2"
                    [class.btn-nav_closed]="(state$ | async) === SidebarState.CLOSED"
                >
                    <app-home></app-home>
                    <span
                        class="d-flex align-items-center label-nav"
                        translate="sidebar.dashboard"
                        id="dashboard"
                        [class.label-nav_hidden]="(state$ | async) === SidebarState.CLOSED"
                    ></span>
                </div>
                <ng-container *ngFor="let route of routes">
                    <div class="block-nav">
                        <ng-container *ngIf="user.type === 'admin'">
                            <div [translate]="'sidebar.title.' + route.title" [class.title-nav_closed]="(state$ | async) === SidebarState.CLOSED" class="d-flex title-nav"></div>
                        </ng-container>

                        <ng-container *ngFor="let item of route.links">
                            <a
                                [routerLink]="item.link"
                                [id]="item.link"
                                [class.btn-nav_closed]="(state$ | async) === SidebarState.CLOSED"
                                routerLinkActive="active"
                                class="d-flex flex-row btn-nav"
                            >
                                <app-icon [name]="item.icon"></app-icon>
                                <span
                                    [translate]="'sidebar.label.' + item.label"
                                    [class.title-nav_closed]="(state$ | async) === SidebarState.CLOSED"
                                    [class.label-nav_hidden]="(state$ | async) === SidebarState.CLOSED"
                                    class="d-flex align-items-center label-nav"
                                ></span>
                            </a>
                        </ng-container>
                    </div>
                </ng-container>
                <a [href]="helpPageLink" target="_blank" rel="noopener" class="d-flex flex-row btn-nav">
                    <app-icon name="help"></app-icon>
                    <span
                        translate="sidebar.label.help"
                        [class.title-nav_closed]="(state$ | async) === SidebarState.CLOSED"
                        [class.label-nav_hidden]="(state$ | async) === SidebarState.CLOSED"
                        class="d-flex align-items-center label-nav"
                    ></span>
                </a>
            </div>
            <div class="sidebar-footer">
                <div class="divider">
                    <div class="d-flex separator"></div>
                </div>
                <div *ngIf="profils?.length" class="btn-nav d-flex flex-row profile" [class.label-nav_hidden]="(state$ | async) === SidebarState.CLOSED">
                    <div class="d-flex flex-column width-100">
                        <div class="d-flex align-items-center">
                            <select id="profilSelector" class="form-select bg-transparent text-white" [(ngModel)]="selectedProfilId" (ngModelChange)="onProfilChange($event)">
                                <option *ngFor="let profil of profils" [value]="profil?.profilId" class="text-dark">
                                    {{ profil?.companyName || ('sidebar.extern' | translate) }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div
                    class="btn-nav d-flex flex-row profile"
                    id="profile"
                    [class.btn-nav_closed]="(state$ | async) === SidebarState.CLOSED"
                    routerLinkActive="active"
                    routerLink="/profile/identity"
                >
                    <app-icon name="profile"></app-icon>
                    <div class="d-flex flex-column">
                        <div
                            [class.title-nav_closed]="(state$ | async) === SidebarState.CLOSED"
                            [class.label-nav_hidden]="(state$ | async) === SidebarState.CLOSED"
                            class="d-flex align-items-center label-nav"
                        >
                            <span class="notranslate">{{ user.firstName }} {{ user.lastName }}</span>
                        </div>
                        <span
                            [class.title-nav_closed]="(state$ | async) === SidebarState.CLOSED"
                            [class.label-nav_hidden]="(state$ | async) === SidebarState.CLOSED"
                            class="d-flex align-items-center sublabel-nav"
                            >{{ authService.getCurrentProfile()?.name || 'sidebar.role.' + user.type | translate }}</span
                        >
                    </div>
                </div>
                <div (click)="logout()" id="logout" class="btn-nav d-flex flex-row">
                    <app-logout></app-logout>
                    <span class="d-flex align-items-center label-nav" translate="sidebar.label.logout" [class.label-nav_hidden]="(state$ | async) === SidebarState.CLOSED"></span>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div class="main-content" [class]="state$ | async">
    <ng-content></ng-content>
</div>
